import { ENDPOINTS } from "../services/Endpoints";
import localStorageService from "./LocalStorageService";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
  putRequest,
} from "./Requests";

export const loginUser = async (values) =>
  postRequest(ENDPOINTS?.login, values);

export const createNewCredentialsForStore = async (data) =>
  postRequest(ENDPOINTS?.saveStore, data);

export const updateStore = async (id, data) =>
  patchRequest(ENDPOINTS?.updateStore(id), data);

export const getAllUser = async (
  page_no = 1,
  size = 15,
  is_paginated = false
) => getRequest(ENDPOINTS.allusers(page_no, size, is_paginated));

export const updateUser = async (id, data) =>
  patchRequest(ENDPOINTS?.updateUser(id), data);

export const getUserDetailsById = async (id) =>
  getRequest(ENDPOINTS.getUser(id));

export const getAllUserRequests = async (
  userId,
  status,
  currentPage,
  pageSize,
  searchQuery,
  requestType
) =>
  getRequest(
    ENDPOINTS.getUserRequests(
      userId,
      status,
      currentPage,
      pageSize,
      searchQuery,
      requestType
    )
  );

export const getRequestDetailsByUserId = async (userId = "", requestId = "") =>
  getRequest(ENDPOINTS.getRequestDetails(userId, requestId));

export const fetchImageById = async (imageId) =>
  getRequest(ENDPOINTS.getFileById(imageId), "blob");

export const approveRequest = async (userId, requestId, data) =>
  patchRequest(ENDPOINTS.userApproveRequest(userId, requestId), data);

export const getAllSKuCategories = async () => {
  const userId = localStorageService.getItem("user_id") || "";
  return getRequest(ENDPOINTS.getSKUCategories(userId));
};

export const getAllInventory = async (item_category = "") => {
  const userId = localStorageService.getItem("user_id") || "";
  return getRequest(ENDPOINTS.getInventory(userId, item_category));
};

export const createNewSkuMapping = async (data) =>
  postRequest(ENDPOINTS?.createskuMapping, data);

export const getAllSkuMapping = async (currentPage, pageSize) =>
  getRequest(ENDPOINTS?.getskuMapping(currentPage, pageSize));

export const getSkuMapplingById = async (mapping_id) =>
  getRequest(ENDPOINTS?.skuMappingById(mapping_id));

export const updateSkuMappling = async (mapping_id, data) =>
  patchRequest(ENDPOINTS?.skuMappingById(mapping_id), data);

export const deleteSkuMapplingById = async (mapping_id) =>
  deleteRequest(ENDPOINTS?.skuMappingById(mapping_id));

export const createPulloutPersonnelList = async (data) =>
  postRequest(ENDPOINTS.addPulloutLetterPersonnel, data, "multipart/form-data");

export const createDiscounts = async (data) =>
  postRequest(ENDPOINTS.addDiscounts, data, "multipart/form-data");

export const getReconciliationInfo = async () =>
  getRequest(ENDPOINTS.getReconciliationInfo);

export const postReconciliationInfo = async (data) =>
  postRequest(ENDPOINTS?.postReconciliationInfo, data, "multipart/form-data");

export const getAllStores = async (page_no = 1, size = 15, query = "") =>
  getRequest(ENDPOINTS.getAllStores(page_no, size, query));

export const createUser = async (data) => postRequest(ENDPOINTS?.users, data);

export const getFileById = async (fileId) =>
  getRequest(ENDPOINTS?.getFileById(fileId));

export const adjustReconciliation = async (reconciliationId, status) =>
  postRequest(ENDPOINTS?.adjustReconciliation(reconciliationId, status));

export const fetchReconciliationHistory = async () =>
  getRequest(ENDPOINTS?.getReconciliationHistory);

export const getReplenishmentEmails = async () =>
  getRequest(ENDPOINTS?.replenishmentEmails);

export const postReplenishmentEmails = async (data) =>
  postRequest(ENDPOINTS?.replenishmentEmails, data);

export const putReplenishmentEmails = async (data) =>
  putRequest(ENDPOINTS?.replenishmentEmails, data);

export const postStoreMonthlyCovers = async (data) =>
  postRequest(ENDPOINTS?.storeMonthlyCovers, data, "multipart/form-data");

export const getInventoryUploads = async (status) =>
  getRequest(ENDPOINTS?.inveontoryUploads(status));

export const getLastProcessedInventoryUpload = async () =>
  getRequest(ENDPOINTS?.lastProcessedInveontoryUpload());

export const getPastInventoryUploads = async () =>
  getRequest(ENDPOINTS.pastInveontoryUploads());

export const retryBulkInventoryUpload = async (uploadId) =>
  putRequest(ENDPOINTS.retryBulkUpload(uploadId));

export const uploadInitialInventory = async (data) =>
  postRequest(ENDPOINTS.addInitialInventory, data, "multipart/form-data");

export const getReplenishmentRequestsWithStatus = async (
  currentPage,
  pageSize,
  status
) =>
  await getRequest(
    ENDPOINTS.getReplenishmentRequestsWithStatus(currentPage, pageSize, status)
  );

export const getReplenishmentRequests = async (currentPage, pageSize) =>
  await getRequest(ENDPOINTS.getReplenishmentRequests(currentPage, pageSize));

export const getReplenishmentRequestDetails = async (
  id,
  currentPage,
  pageSize
) =>
  await getRequest(
    ENDPOINTS.getReplenishmentRequestDetails(id, currentPage, pageSize)
  );

export const updateReplenishmentRequestItemQuantity = async (itemQuantity) =>
  await patchRequest(
    ENDPOINTS.updateReplenishmentRequestItemQuantity(),
    itemQuantity
  );

export const updateReplenishmentRequestStatus = async (requestId, isApproved) =>
  await putRequest(ENDPOINTS.updateReplenishmentRequestStatus(requestId), {
    is_approved: isApproved,
  });


export const getOngoingPromotions = async () =>  await getRequest(ENDPOINTS.getPromotions());

export const updatePromotion = async (promotion) =>  await putRequest(ENDPOINTS.updatePromotion(), promotion);
